// @flow

import {Location} from 'docs/data/location/Location';
import type {SetLocationFunction} from 'docs/data/location/LocationProvider';

import type {Navigation} from 'docs/data/navigation/Navigation';
import type {
  Action,
  FocusAction,
  RemovePaneAction,
  FocusPaneAction,
  InvokeCommandAction,
  UpdatePaneAction,
  PrintOutputAction,
} from './reducer';

type Dispatch = (Action) => void;

export const setFocus = (dispatch: Dispatch) => (
  payload: $PropertyType<FocusAction, 'payload'>,
) => {
  dispatch({type: 'SET_FOCUS', payload});
};

export const addPane = (dispatch: Dispatch) => () =>
  dispatch({type: 'ADD_PANE'});

export const removePane = (dispatch: Dispatch) => (
  payload: $PropertyType<RemovePaneAction, 'payload'>,
) => {
  dispatch({type: 'REMOVE_PANE', payload});
};

export const focusPane = (dispatch: Dispatch) => (
  payload: $PropertyType<FocusPaneAction, 'payload'>,
) => {
  dispatch({type: 'FOCUS_PANE', payload});
};

export const open = (
  dispatch: Dispatch,
  location: Location,
  replaceLocation: SetLocationFunction,
) => () => {
  dispatch({type: 'OPEN'});
  replaceLocation({
    query: {...location.query, shell: 'true'},
  });
};

export const close = (
  dispatch: Dispatch,
  location: Location,
  replaceLocation: SetLocationFunction,
) => () => {
  dispatch({type: 'CLOSE'});
  const {shell, ...remainingQuery} = location.query;
  replaceLocation({
    query: remainingQuery,
  });
};

export const invokeCommand = (dispatch: Dispatch) => (
  payload: $PropertyType<InvokeCommandAction, 'payload'>,
) => {
  dispatch({type: 'INVOKE_COMMAND', payload});
};

export const updatePane = (dispatch: Dispatch, navigation: Navigation) => (
  payload: $PropertyType<UpdatePaneAction, 'payload'>,
) => {
  dispatch({type: 'UPDATE_PANE', payload, navigation});
};

export const reset = (dispatch: Dispatch) => () => dispatch({type: 'RESET'});

export const lockPanes = (dispatch: Dispatch) => () =>
  dispatch({type: 'LOCK_PANES'});

export const unlockPanes = (dispatch: Dispatch) => () =>
  dispatch({type: 'UNLOCK_PANES'});

export const printOutput = (dispatch: Dispatch) => (
  payload: $PropertyType<PrintOutputAction, 'payload'>,
) => dispatch({type: 'PRINT_OUTPUT', payload});

export const toggleApiExplorer = (dispatch: Dispatch) => () =>
  dispatch({type: 'TOGGLE_API_EXPLORER'});
